import { render } from "./KreyativHero.vue?vue&type=template&id=48a338ec&scoped=true"
const script = {}

import "./KreyativHero.vue?vue&type=style&index=0&id=48a338ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a338ec"]])

export default __exports__